import PropTypes from "prop-types";
import React, { useState } from "react";
import _ from "lodash";
import moment from "moment";
import submit from "submit-form";

import { buildSupersets } from "../../../../utils/prefix-calculator";

const {
  DATE_FORMATS: { DATE_YEAR_FORMAT, DATE_DAY_FORMAT },
  PROGRAM_ICONS,
} = require("../../../../constants");

import getSessionOrder from "../../../../utils/get-session-order";

import MonthExercise from "./MonthExercise";
import { getUserToRequest } from "../../settings/manage-coaches/utils/manage-coaches-utils";
import SvgIcon from "../../../../parts/SvgIcon";

function MonthDay(
  {
    date,
    hasWorkout,
    handleSelectDate,
    isSelected,
    selectedDates,
    scheduledSessions,
    handleRemoveMultiple,
    dragging,
    expanded,
  },
  {
    locals: {
      activeUser,
      cycles = [],
      query,
      withWeight,
      fromMetric,
      organizationOwner,
      activeUserToRequest,
    },
  }
) {
  const userToMeasure = getUserToRequest(activeUser, organizationOwner);
  const isInActiveMonth =
    date.clone().month() === moment(query.month, DATE_YEAR_FORMAT).month();
  const dayString = date.clone().format(DATE_DAY_FORMAT);
  const isToday = dayString === moment().format(DATE_DAY_FORMAT);
  const isPast = date.clone().isBefore(moment(), "day");
  const exercises = scheduledSessions[dayString];
  const cycleDetail = _.get(_.find(exercises, "cycle"), "cycle", {});
  const cycle = _.find(cycles, (cyc) => cyc._id == cycleDetail.id);
  const supersets = buildSupersets(exercises);

  const program = cycle
    ? _.find(cycle.programs, (prog) => prog.order == cycleDetail.program)
    : {};
  const session = { exercises, order: cycleDetail.programSession };

  const sessionOrderInProgram = getSessionOrder(
    program,
    cycleDetail.programWeek,
    session.order
  );

  let units = activeUser.units;
  let round = userToMeasure.round;

  const intensityMeasure =
    _.get(activeUserToRequest, "intensityMeasure", "rpe") === "rpe"
      ? "RPE"
      : "RiR";
  const isRiR = intensityMeasure === "RiR";

  const renderMenuOptions = () => {
    const [opened, setOpened] = useState(false);
    return (
      <div className="more">
        <input type="radio" name="more" id={`more-${dayString}`} />
        <div className="drag-icon cursor-grab">
          <img src="/img/new-icons/drag-outline.svg" alt="drag" />
        </div>
        {/* <label className="trigger" htmlFor={`more-${dayString}`}>
          <img src="/img/svg/icon_more.svg" alt="dismiss" />
        </label>
        <label className="close" htmlFor="more-reset">
          <img src="/img/svg/icon_dismiss_white.svg" alt="dismiss" />
        </label>
        <div className="content">
          <a
            href={`/actions/refresh?view=day&date=${date.format(
              DATE_DAY_FORMAT
            )}`}
          >
            View
          </a>
          <a
            href={`/actions/refresh?modal[type]=calendar-move-workout&day=${date.format(
              DATE_DAY_FORMAT
            )}`}
          >
            Move
          </a>
          <a
            href={`/actions/refresh?modal[type]=calendar-shift-workout&day=${date.format(
              DATE_DAY_FORMAT
            )}`}
          >
            Shift
          </a>
          <a
            href={`/actions/refresh?modal[type]=calendar-duplicate-workout&day=${date.format(
              DATE_DAY_FORMAT
            )}`}
          >
            Duplicate
          </a>
          <a href="#" onClick={(e) => handleRemoveMultiple(e, date)}>
            Remove
          </a>
        </div> */}
        <details role="list" open={opened}>
          <summary
            onClick={(e) => {
              e.preventDefault();
              setOpened(!opened);
            }}
            onBlur={(e) => {
              e.preventDefault();
              setOpened(false);
            }}
            aria-haspopup="listbox"
            className="!p-0 !h-auto"
          >
            <SvgIcon src="/img/new-icons/vuesax-linear-add-square.svg" />
          </summary>
          <ul role="listbox" className={opened ? "opened" : ""}>
            <li
              onMouseDown={() => {
                submit(`/actions/refresh?`, {
                  method: "GET",
                  body: {
                    view: "day",
                    date: date.format(DATE_DAY_FORMAT),
                  },
                });
              }}
            >
              <a>View</a>
            </li>
            <li
              onMouseDown={() => {
                submit(`/actions/refresh?`, {
                  method: "GET",
                  body: {
                    "modal[type]": "calendar-move-workout",
                    day: date.format(DATE_DAY_FORMAT),
                  },
                });
              }}
            >
              <a>Move</a>
            </li>
            <li
              onMouseDown={() => {
                submit(`/actions/refresh?`, {
                  method: "GET",
                  body: {
                    "modal[type]": "calendar-shift-workout",
                    day: date.format(DATE_DAY_FORMAT),
                  },
                });
              }}
            >
              <a>Shift</a>
            </li>
            <li
              onMouseDown={() => {
                submit(`/actions/refresh?`, {
                  method: "GET",
                  body: {
                    "modal[type]": "calendar-duplicate-workout",
                    day: date.format(DATE_DAY_FORMAT),
                  },
                });
              }}
            >
              <a>Duplicate</a>
            </li>
            <li onMouseDown={(e) => handleRemoveMultiple(e, date)}>
              <a className="!text-[--danger]">Remove</a>
            </li>
          </ul>
        </details>
      </div>
    );
  };

  const renderHeader = () => (
    <div className="day-header">
      <SvgIcon
        className="cursor-pointer"
        onClickFn={(e) => handleSelectDate(e, dayString)}
        src={
          selectedDates.includes(dayString)
            ? "/img/new-icons/checked-square.svg"
            : "/img/new-icons/unchecked-square.svg"
        }
        noFilterOnLight={selectedDates.includes(dayString)}
      />
      <div className="date-container">
        <div className="date-text">{date.format("D")}</div>
      </div>
    </div>
  );

  const renderExercises = () => (
    <div className={`exercises-frame${expanded ? " expanded" : ""}`}>
      <ul className={`exercises-list${expanded ? " expanded" : ""}`}>
        {_.times(session.exercises.length, (idx) => {
          const exercise = session.exercises[idx];
          if (!exercise) return null;
          return (
            <MonthExercise
              key={exercise._id}
              exercise={exercise}
              supersets={supersets}
              withWeight={withWeight}
              fromMetric={fromMetric}
              units={units}
              round={round}
              expanded={expanded}
              intensityMeasure={intensityMeasure}
              isRiR={isRiR}
              date={date.format(DATE_DAY_FORMAT)}
              showCopyButton={false}
            />
          );
        })}
      </ul>
    </div>
  );

  const renderFloatingHeader = () => (
    <div className="floating-header">
      <label
        className={`selector${
          selectedDates.includes(dayString) ? " selected" : ""
        }`}
        id={`select-${dayString}`}
        onClick={(e) => handleSelectDate(e, dayString)}
      />
      {selectedDates.length < 2 ? renderMenuOptions() : null}
    </div>
  );

  return (
    <div
      className={`day ${!isInActiveMonth ? " alt-other-month" : ""}${
        isPast ? " alt-past" : isToday ? " alt-today" : ""
      }${expanded ? " expanded" : ""}`}
    >
      <div
        className={`day-margin${
          session.exercises ? " draggable-dropzone--occupied" : ""
        }${expanded ? " expanded" : ""}`}
        id={`container-${dayString}`}
      >
        {renderHeader(Boolean(session.exercises))}
        {session.exercises ? (
          <div className="day-draggable" id={dayString}>
            {renderFloatingHeader()}
            {renderExercises()}
          </div>
        ) : null}
        {!dragging ? (
          <a
            className="add"
            href={`/actions/refresh?modal[type]=calendar-add-exercise&day=${date.format(
              DATE_DAY_FORMAT
            )}`}
          >
            <SvgIcon
              className="h-11 w-11"
              src="/img/new-icons/add-square-outline.svg"
              alt="add workout"
            />
            <p className="p4">Add Workout</p>
          </a>
        ) : null}
      </div>
    </div>
  );
}

MonthDay.contextTypes = { locals: PropTypes.object };

function handleRemove(e, date) {
  e.preventDefault();

  submit(
    `/actions/exercise/unschedule-workout?date=[${date.format(
      DATE_DAY_FORMAT
    )}]`,
    {
      method: "POST",
      body: {
        days: [date.clone().toDate()],
      },
    }
  );
}

export default MonthDay;
